<template>
  <div class="sequence-suggestions">
    <el-input
      class="mb-4"
      style="width: 100%; /*position: sticky; top: 0px;*/"
      v-model="search_string"
      placeholder="Search…"
      :fetch-suggestions="querySearch"
      :clearable="true"
      ref="input">
      <el-button slot="append">
        <font-awesome-icon icon="search" />
      </el-button>
    </el-input>

    <el-collapse v-model="collapse_list">
      <el-collapse-item
        v-for="suggestion_item_list in suggestion_item_lists_grouped_and_filtered"
        :key="suggestion_item_list.$key"
        :title="suggestion_item_list.title"
        :name="suggestion_item_list.$id">

        <draggable
          v-model="suggestion_item_list.items"
          :disabled="false"
          :animation="0"
          draggable=".action-draggable"
          :ghostClass="'suggestion-sortable-ghost' /* Class name for the drop placeholder */"
          :chosenClass="'sortable-chosen' /* Class name for the chosen item */"
          :dragClass="'sortable-drag' /* Class name for the dragging item */"
          :sort="false /* To disable sorting: set sort to false */"
          :emptyInsertThreshold="50"
          :group="{
            name: 'sequence',
            pull: 'clone',
            put:  false // Do not allow items to be put into this list
          }"
          @end="onDragEnd"
          :move="onDragMove"
          :clone="cloneItem">
          <!-- @clone="onClone" -->

          <!-- TODO: pass entire suggestion_item to comp! -->
          <SequenceSuggestionItem
            class="action-draggable"
            v-for="suggestion_item in suggestion_item_list.items"
            :key="suggestion_item.$key"
            :item-id="suggestion_item.$id"
            :title-html="suggestion_item.matched_text || suggestion_item.title"
            :href="suggestion_item.href"
            :description="suggestion_item.description"
            :icon="suggestion_item.icon.symbol || 'circle-question'"
            :icon-bg-color="suggestion_item.icon.bgColor || 'black'"
            :icon-fg-color="suggestion_item.icon.fgColor || 'white'"
            @add="onAddItem( suggestion_item_list.$id, suggestion_item )"
            />
        </draggable>

      </el-collapse-item>
    </el-collapse>

    <pre class="mini-pre" v-if="SHOW_DEBUG">{{suggestion_item_lists_grouped_and_filtered}}</pre>
  </div>
</template>

<script>
import Draggable from 'vuedraggable';
import Fuse from 'fuse-js-latest'
import SequenceSuggestionItem from './Elements/SequenceSuggestionItem'
import SUGGESTION_DATA from './Data/suggestions-data.js'
import clonedeep from 'lodash.clonedeep'

const SEARCH_OPTIONS = {
  shouldSort: true,
  tokenize: true,
  threshold: 0.5,
  location: 0,
  distance: 100,
  includeMatches: true,
  maxPatternLength: 32,
  minMatchCharLength: 1,
  keys: [
    "title",
    "description",
  ]
};

export default {
  data: () => ({
    collapse_list: [-1, 1, 2],
    search_string: '',
    search_result: null,
    search_cache: [],
    suggestion_cache: [],
  }),
  created() {
    this.makeSearchCache();
    this.fuse = new Fuse(this.search_cache, SEARCH_OPTIONS);
  },
  computed: {
    suggestion_item_lists_grouped_and_filtered() {
      // TODO: Filter with this.search_string or use Fuse library for fulltext search
      // filter(item => item.title.includes( this.search_string ))
      if ( this.search_result !== null ) {
        return [{
          $id: -1,
          $key: '-1',
          title: 'Search result',
          items: this.search_result
        }];
        // return {
        //   this.search_result.map(search_result_item => {
        //     this.suggestion_cache[]
        //     search_result_item.$id
        //     search_result_item.$groupId
        //     search_result_item.for
        //   })
        // }
      }
      return this.suggestion_cache
    },
  },
  watch: {
    search_string( query ) {
      if ( query ) {
        this.querySearch( query, (res) => {
          this.search_result = res;
        })
      } else {
        this.search_result = null;
      }
    }
  },
  methods: {
    makeSearchCache() {
      let search_cache = [];
      for ( let group_idx in SUGGESTION_DATA ) {
        let group_id = SUGGESTION_DATA[ group_idx ].$id;
        let items = SUGGESTION_DATA[ group_idx ].items
        for ( let item_idx in items ) {
          items[ item_idx ].$groupId = group_id;
          // search_cache.push({
          //   title: items[ item_idx ].title,
          //   description: items[ item_idx ].description,
          //   $id: items[ item_idx ].$id,
          //   $groupId: group_id
          // })
          search_cache.push(items[ item_idx ])
        }
      }
      this.search_cache = search_cache;
      this.suggestion_cache = SUGGESTION_DATA;
      // console.log("this.search_cache", this.search_cache);
      // console.log("this.suggestion_cache", this.suggestion_cache);
    },
    querySearch(query_string, cb) {
      var results = this.fuse.search(query_string);

      results = results.map(result => {
        let matches = result.matches.map(match => match.indices);
        matches = [].concat.apply([], matches);

        return {
          ...result.item,
          matched_text: this.formatMatches( result.item.title, matches )
        };
      });

      console.log("[search] results", results);

      cb(results);
    },
    formatMatches( text, matches ) {
      // TODO: Doppelt!! Move to mixin
      /* Build a formatted string */
      let result = [];
      var pair = matches.shift()
      for ( var i = 0; i < text.length; i++ ) {
        var char = text.charAt(i)
        if ( pair && i === pair[0] ) {
          result.push('<strong>')
        }
        if ( char === '<' ) {
          result.push('<span class="no-style">')
        } else if ( char === '>' ) {
          result.push('</span>')
        } else {
          result.push(char)
        }
        if ( pair && i === pair[1] ) {
          result.push('</strong>')
          pair = matches.shift()
        }
      }
      return result.join('');
    },
    // onClone(/**Event*/evt) {
    //   var origEl = evt.item;
    //   var cloneEl = evt.clone;
    //   console.log("onClone", origEl, cloneEl, evt);
    // },
    cloneItem( item ) {
      console.log('cloneItem 123')
      let item_clone = clonedeep( item ) // convert to generic model?
      // let item_clone = JSON.parse( JSON.stringify( item ) );
      // item_clone.actions[0].sessionLength = Math.random() * 1000;
      // console.log("CLONE A", JSON.stringify( item_clone ));
      item_clone.id = item_clone.$id;
      item_clone.groupId = item_clone.$groupId;
      delete item_clone.$key /* remove key */
      delete item_clone.$id /* remove key */
      delete item_clone.$groupId /* remove key */
      item_clone.description = null; /* Remove description, so user can set it */
      return item_clone;
    },
    onAddItem( groupId, item ) {
      let item_clone = this.cloneItem( item );
      // console.log("CLONE B", item_clone);
      this.$emit('add', item_clone /* { ...item, $groupId: groupId }*/) // DOPPELT
    },
    addItem( groupId, itemId ) {
      let item = this.search_cache.find(item => item.$id === itemId && item.$groupId === groupId );
      if ( item ) {
        let item_clone = this.cloneItem( item );
        this.$emit('add', item_clone)
      }
    },
    onDragEnd(evt) {
      this.$emit('drag-end', evt)
    },
    onDragMove(evt) {
      this.$emit('first-move', evt)
    }
  },
  components: {
    SequenceSuggestionItem,
    Draggable
  }
}
</script>

<style>
.sequence-suggestions {
  padding: 0.75em;
  height: 100vh;
  overflow-y: scroll;
  border-left: 1px solid gray;
}
</style>
